import { Link } from "react-scroll";

export const Logo = () => {
  return (
    <Link
      to="top"
      smooth={true}
      delay={100}
      duration={700}
      className="font-normal flex gap-0.5 items-center text-sm mr-4  text-black md:px-2  relative z-20 cursor-pointer"
    >
      <img
        src={
          window.siteUrl +
          "/wp-content/plugins/innovative-design/public/logo/symbol.svg"
        }
        alt=""
        className="size-8"
      />
      <div className="notranslate">
        <span className="text-white text-xl">hiz</span>
        <span className="text-white font-bold text-xl">
          <span>man</span>
          <span>age</span>
        </span>
      </div>
    </Link>
  );
};
